import { ISelectOption } from "./selectOption.interface";
import { SupportTicketSeverity as SupportTicketSeverity } from "../api/support/supportTicketSeverity.enum";
import { LabelsProviderPipe } from "src/app/pipes/labels-provider/labels-provider.pipe";
import { Injectable } from "@angular/core";

@Injectable()
export class SupportTicketSeveritySelectOptions {
    constructor(private _labelsProviderPipe: LabelsProviderPipe) {}
    public generate(): ISelectOption[] {
        return [
            {
                id: SupportTicketSeverity.low.toString(),
                value: SupportTicketSeverity.low.toString(),
                displayName: this._labelsProviderPipe.transform("supportPage.tickets.severityLabels.low"),
            },
            {
                id: SupportTicketSeverity.normal.toString(),
                value: SupportTicketSeverity.normal.toString(),
                displayName: this._labelsProviderPipe.transform("supportPage.tickets.severityLabels.minor"),
            },
            {
                id: SupportTicketSeverity.high.toString(),
                value: SupportTicketSeverity.high.toString(),
                displayName: this._labelsProviderPipe.transform("supportPage.tickets.severityLabels.major"),
            },
            {
                id: SupportTicketSeverity.urgent.toString(),
                value: SupportTicketSeverity.urgent.toString(),
                displayName: this._labelsProviderPipe.transform("supportPage.tickets.severityLabels.critical"),
            },
        ];
    }
}
